import React, * as react from 'react';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';

import { kratosApi } from './kratos/common';
import { useReturn } from './ReturnTo';
import { useInvalidateFlowsAndUser } from './kratos/useInvalidateFlowsAndUser';

/*
React Component providing a Logout button.
*/
export default function Logout(props: LogoutProps) {
  const [logoutState, setLogoutState] = react.useState('ready');
  const goReturn = useReturn().go;
  const invalidateFlowsAndUser = useInvalidateFlowsAndUser();

  function handleInitiateLogout() {
    void Promise.all([
      logout(setLogoutState, goReturn, invalidateFlowsAndUser)
    ]);
  }

  react.useEffect(function maybeLogoutImmediately() {
    if (props?.immediate !== true || logoutState !== 'ready') {
      return;
    }
    handleInitiateLogout();
  }, [props.immediate, logoutState, handleInitiateLogout]);

  return (
    <Button
      onClick={handleInitiateLogout}
      disabled={logoutState !== 'ready'}
      variant="contained"
      size="large"
      color="secondary"
    >
      Logout
    </Button>);
}

interface LogoutProps
{
  immediate?: boolean;
}

async function logout(
  setLogoutState: (state: string) => void,
  goReturn: () => void,
  invalidateFlowsAndUser: ReturnType<typeof useInvalidateFlowsAndUser>
) {
  try {
    setLogoutState('preparing');
    const flow = await kratosApi.createBrowserLogoutFlow();
    const token = flow.data.logout_token;
    setLogoutState('logging out');
    await kratosApi.updateLogoutFlow({ token });
    setLogoutState('success');
    await invalidateFlowsAndUser();
    goReturn();
  }
  catch (error) {
    setLogoutState('error');
    throw error;
  }
}
